import * as Yup from 'yup';

export const editSchema = Yup.object().shape({
  shipmentNumbers: Yup.array(Yup.string()).min(1, `shipment field must have at least 1 items`),
  _courierId: Yup.string().trim().required('CSP is required'),
});
